// For Home Page
import React from "react";
import Layer2 from '../HomeScreen/Layer2'
// import Layer2 from "./Layer2";
import Layer3 from "../HomeScreen/Layer3";
import Layer4 from "../HomeScreen/Layer4";
import Investors from "../HomeScreen/Investors";
import Layer6 from "../HomeScreen/Layer6";
import Footer from "../HomeScreen/Footer";
import Landing from "../HomeScreen/Homepage";

const Parent = () => {
    return (
      <div>
        <Landing/>
        {/* <div id="why-us">
          <Layer2/>
        </div> */}
        <Layer2/>
        <div id="industry-solutions">
          <Layer3/>
        </div>
        {/* <Layer3/> */}
        <Layer4/>
        <Investors/>
        <Layer6/>
        {/* <Footer/> */}
      </div>  
    );
}

export default Parent;